// /home/ciancio/scherzo/src/App.js
import React, { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, Navigate, Link } from "react-router-dom";
import Book from "./pages/Book";
import Confirmation from "./pages/Confirmation";
import Home from "./pages/Home";
import Gate from "./pages/Gate";

export default function App() {
  // audio: public file path (encode to be safe with spaces / #)
  const audioSrc = typeof window !== "undefined" ? encodeURI("./19.mp3") : "./19.mp3";
  const audioRef = useRef(null);

  // Try to autoplay on mount; browsers may block autoplay without user gesture — swallow any errors.
  useEffect(() => {
    const a = audioRef.current;
    if (!a) return;
    a.loop = true;
    a.preload = "auto";
    a.volume = 0.18;
    const p = a.play();
    if (p && typeof p.then === "function") p.catch(() => {});
  }, []);
  
  // comic style for the main "Scherzo" title in the navbar — use Comic Relief
  const comicTitleStyle = {
    fontFamily: '"Comic Relief", "Comic Neue", "Comic Sans MS", "Comic Sans", cursive',
    textDecoration: "none",
    color: "inherit",
    fontSize: "1.6em",
  };

  // app background: use single monogram tile from public/monogram.png
  const appBgStyle = {
    display: "flex",
    flexDirection: "column",

    /* single monogram image (no repeat) with a translucent white overlay */
    backgroundImage: `
      linear-gradient(rgba(255, 255, 255, 0.92), rgba(255,255,255,0.92)),
      url('/monogram.png')
    `,
    backgroundRepeat: "no-repeat, no-repeat",
    /* keep aspect ratio (no distortion) and make the image cover the viewport */
    backgroundSize: "auto, cover",
    backgroundPosition: "center center, center center",

    alignItems: "center",
    // ensure app-level fallback uses Comic Relief first
    fontFamily: '"Comic Relief", "Comic Neue", "Comic Sans MS", "Comic Sans", cursive',
    textAlign: "center",
    paddingBottom: 72,
    maxWidth: "100vw",
  };


  return (
    <div className="app-shell" style={appBgStyle}>
      {/* background audio (hidden controls) */}
      <audio ref={audioRef} src={audioSrc} loop preload="auto" />
      {/* Global font rule: use Comic Relief (Google font) with fallbacks to Comic Neue / system Comic Sans */}
      <style>{`
        /* No stylesheet ships with this app, so the UA defaults are still live:
           body carries margin:8px and everything is content-box. Both push the
           page past the viewport and produce a scrollbar with nothing to scroll. */
        *, *::before, *::after { box-sizing: border-box; }
        html, body, #root { margin: 0; padding: 0; }
        body { overflow-x: hidden; }

        /* 100vh on mobile means "viewport with the browser chrome retracted",
           which is taller than what you can actually see — so it scrolls even
           when the content fits. dvh tracks the real visible height; the vh
           line stays first as the fallback for older browsers. */
        .app-shell {
          min-height: 100vh;
          min-height: 100dvh;
          /* overflow-x:hidden forces the OTHER axis to compute to auto, which
             quietly turns this div into a vertical scroll container. clip
             hides the horizontal overflow without that side effect; the
             hidden line above it is the fallback for older browsers. */
          overflow-x: hidden;
          overflow-x: clip;
        }

        /* Apply to most textual elements so the entire app uses the same font */
        html, body, #root, body * {
          font-family: "Comic Relief", "Comic Neue", "Comic Sans MS", "Comic Sans", cursive !important;
        }
        /* Keep inputs/buttons readable */
        input, textarea, select, button {
          font-family: "Comic Relief", "Comic Neue", "Comic Sans MS", "Comic Sans", cursive !important;
        }
      `}</style>
      <BrowserRouter>
        <header style={{ padding: 12, display: "flex", gap: 16, justifyContent: "center" }}>
          <Link to="/" style={comicTitleStyle} className="nav-title">Scherzo</Link>
          <Link to="/book" style={comicTitleStyle} className="nav-title">
            Varaa
          </Link>
        </header>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/book" element={<Book />} />
          <Route path="/confirmation" element={<Confirmation />} />
          {/* Admin. Deliberately absent from the header nav. */}
          <Route path="/gate" element={<Gate />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
